export function initTabbedTextElement() {
    document.querySelectorAll('.tabbedTextElement').forEach(el => {
        const tabs   = [...el.querySelectorAll('.tabbedTextElement__tab')];
        const panels = [...el.querySelectorAll('.tabbedTextElement__panel')];

        if (!tabs.length) return;

        function activate(index) {
            tabs.forEach((t, i)   => t.classList.toggle('is-active', i === index));
            panels.forEach((p, i) => p.classList.toggle('is-active', i === index));
        }

        tabs.forEach((tab, i) => tab.addEventListener('click', () => activate(i)));

        activate(0);
    });
}
